import styled from 'styled-components';

export const InnerBlock = styled.div`
  display: inherit;
  flex-direction: inherit;
  gap: 30px;
`;

export const RowBlock = styled.div`
  position: relative;
  display: inherit;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
